module.exports = __webpack_public_path__ + "static/img/gbFlag.db0e0dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/gbFlag.svg
// module id = X7is
// module chunks = 55